function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { LOAD_QUALIFICATIONS_SUCCESS, LOAD_QUALIFICATIONS_FAILURE, LOAD_QUALIFICATION_REQUEST, LOAD_QUALIFICATION_SUCCESS, LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_REQUEST, LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_SUCCESS, LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_FAILURE, LOAD_DEVELOPER_QUALIFICATIONS_REQUEST, LOAD_DEVELOPER_QUALIFICATIONS_SUCCESS, LOAD_DEVELOPER_QUALIFICATIONS_FAILURE } from '../ActionType';
import * as QualificationAPI from '../../api/QualificationAPI';
import map from 'lodash/map';
export var getQualifications = function(countryId, languageId, targetingQIDHash) {
    return function() {
        var _ref = _async_to_generator(function(dispatch) {
            var result, qualifications, qualificationsHash, targetingQualification, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (targetingQIDHash) {
                            dispatch({
                                type: LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_REQUEST,
                                payload: {
                                    countryId: countryId,
                                    languageId: languageId
                                }
                            });
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            QualificationAPI.qualificationList(countryId, languageId)
                        ];
                    case 2:
                        result = _state.sent();
                        qualifications = result.data.data;
                        // Build hash for quicker loop up
                        qualificationsHash = qualifications.reduce(function(curr, elem) {
                            var elemWithId = _object_spread_props(_object_spread({}, elem.attributes), {
                                id: elem.id
                            });
                            curr.questionIdHash[elem.attributes.question_id] = elemWithId;
                            curr.qualificationIdHash[elem.id] = elemWithId;
                            return curr;
                        }, {
                            questionIdHash: {},
                            qualificationIdHash: {}
                        });
                        dispatch({
                            type: LOAD_QUALIFICATIONS_SUCCESS,
                            payload: {
                                qualifications: qualificationsHash.qualificationIdHash
                            }
                        });
                        if (targetingQIDHash) {
                            try {
                                // Build targetQualification
                                targetingQualification = map(targetingQIDHash, function(group) {
                                    return {
                                        name: group.name,
                                        qualifications: group.qids.map(function(id) {
                                            return qualificationsHash.questionIdHash[id.toString()];
                                        }).filter(function(data) {
                                            return data;
                                        })
                                    };
                                });
                                dispatch({
                                    type: LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_SUCCESS,
                                    payload: {
                                        targetingQualification: targetingQualification,
                                        countryId: countryId,
                                        languageId: languageId
                                    }
                                });
                            } catch (err) {
                                dispatch({
                                    type: LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_FAILURE,
                                    payload: {
                                        error: err.message
                                    }
                                });
                            }
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        dispatch({
                            type: LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_FAILURE,
                            payload: {
                                error: e.message
                            }
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var getQualification = function(id) {
    return function() {
        var _ref = _async_to_generator(function(dispatch) {
            var result, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dispatch({
                            type: LOAD_QUALIFICATION_REQUEST,
                            payload: {
                                id: id
                            }
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            QualificationAPI.get(id)
                        ];
                    case 2:
                        result = _state.sent();
                        dispatch({
                            type: LOAD_QUALIFICATION_SUCCESS,
                            payload: {
                                qualification: result.data
                            }
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        return [
                            2,
                            dispatch({
                                type: LOAD_QUALIFICATIONS_FAILURE,
                                payload: {
                                    error: e.message
                                }
                            })
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var getQualificationTopics = function(countryId, languageId) {
    return function() {
        var _ref = _async_to_generator(function(dispatch) {
            var result, targetingQualifications, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dispatch({
                            type: LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_REQUEST,
                            payload: {
                                countryId: countryId,
                                languageId: languageId
                            }
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            QualificationAPI.listWithTopics(countryId, languageId)
                        ];
                    case 2:
                        result = _state.sent();
                        // Build targetQualification
                        targetingQualifications = result.data;
                        dispatch(getQualifications(countryId, languageId, targetingQualifications));
                        dispatch({
                            type: LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_SUCCESS,
                            payload: {
                                targetingQualifications: targetingQualifications,
                                countryId: countryId,
                                languageId: languageId
                            }
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        dispatch({
                            type: LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_FAILURE,
                            payload: {
                                error: e.message
                            }
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var getDeveloperQualifications = function(countryId, languageId) {
    return function() {
        var _ref = _async_to_generator(function(dispatch) {
            var _ref, qualifications, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dispatch({
                            type: LOAD_DEVELOPER_QUALIFICATIONS_REQUEST
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            QualificationAPI.getDeveloperQualifications(countryId, languageId)
                        ];
                    case 2:
                        _ref = _state.sent(), qualifications = _ref.data;
                        dispatch({
                            type: LOAD_DEVELOPER_QUALIFICATIONS_SUCCESS,
                            payload: {
                                qualifications: qualifications
                            }
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        dispatch({
                            type: LOAD_DEVELOPER_QUALIFICATIONS_FAILURE,
                            payload: {
                                error: e.message
                            }
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
